import { useEffect } from 'react';
import type { FC } from 'react';
import { Avatar, Col, Row } from 'antd';
import { TbChevronDown, TbUser } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import DropdownButton from '@/shared/components/dropdowns/DropdownButton';
import { useUserStore } from '@/stores/database/entities/00-RBAC/01-Users/store';
import { usePresenceStore } from '@/stores/realtime/presence';
import { ellipsisStyling } from '@/utilities/styles/ellipsisStyling';

import { StatusBadge } from '../../badges';

const UserDropdownButton: FC = (): JSX.Element => {
    const { selectedUser: user, fetchUser } = useUserStore();

    const { users } = usePresenceStore();

    useEffect(() => {
        if (!user?.id) {
            fetchUser();
        }
    }, [fetchUser, user?.id]);

    const presence = users[user?.id as string];
    const status = presence?.status ?? 'offline';

    // const lastSeenAt = presence?.lastSeenAt;

    const { token } = useAntDesignTheme();

    return (
        <DropdownButton
            trailingIcon={
                <TbChevronDown size='1rem' style={{ color: token.colorTextTertiary, verticalAlign: '-0.125rem' }} />
            }
            type='text'
            style={{
                borderColor: token.colorBorder,
                justifyContent: 'flex-start',
            }}
        >
            <Row style={{ width: '100%' }}>
                <Col flex='auto' style={{ textAlign: 'left' }}>
                    <StatusBadge borderColor={token.colorBgContainer} offset={[-3, 15]} status={status}>
                        <Avatar size={16} style={{ verticalAlign: '-0.175rem' }} icon={<TbUser />} src={user?.avatar} />
                    </StatusBadge>
                    <span
                        style={{
                            fontWeight: 500,
                            padding: '0 0.5rem',
                            paddingRight: '0.375rem',
                            maxWidth: 16 * 8,
                            ...ellipsisStyling,
                        }}
                    >
                        {user?.firstName ?? 'Your Account'}
                    </span>
                </Col>
            </Row>
        </DropdownButton>
    );
};

export default UserDropdownButton;
